import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای داشبورد برنامه‌ریزی

داشبورد اصلی ماژول برنامه‌ریزی که وضعیت برنامه‌های کلان و نیازمندی‌های مواد را در یک نگاه نشان می‌دهد.

## ۱. نمای کلی
اطلاعاتی از قبیل تعداد MPS های باز، خروجی‌های MRP و وضعیت ظرفیت ایستگاه‌ها در این صفحه قرار دارد.

## ۲. میانبرها
دسترسی سریع به ایجاد برنامه کلان تولید و اجرای محاسبات متریال (MRP) امکان‌پذیر است.

export default Layout;
